// extracted by mini-css-extract-plugin
export default {"outer-wrapper":"styles_outer-wrapper__zXzqP","button":"styles_button__fzCTe","star":"styles_star__E7JP0","product-image-container":"styles_product-image-container__x0RJn"};